import { Context, Effect } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
export class DatabasePrompts extends Context.Service<DatabasePrompts, {
  readonly ask: (message: string) => Effect.Effect<string | null, ResourceFailure>;
}>()("workerstation/frontend/DatabasePrompts") {}
